// Import from NPM
// -------------------------------------
import React, { useState, useEffect } from "react";

import { Div } from "@components/Generics.react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
// import Editor from "ckeditor5-custom-build/build/ckeditor";
import Editor from "@ckeditor/ckeditor5-build-balloon-block";
export default function HTMLField(props) {
    const { target, header, help, value, setValue, height, maxLength } = props;
    const [isMounted, setIsMounted] = useState(false);
    const [inputValue, setInputValue] = useState(
        target && value ? value[target] || "" : value
    );

    // Debouncing the user input
    //==================================
    useEffect(() => {
        setIsMounted(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (isMounted)
                setValue(target ? { [target]: inputValue } : inputValue);
        }, 500);
        return () => clearTimeout(timeoutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue]);

    const inputLength = inputValue
        ? inputValue.toString().replace(/<[^>]*>?/gm, "").length
        : 0;

    // ========================= Render Function =================================
    return (
        <Div minHt={height} ht={height} basepad ivory snug>
            {header && (
                <Div big rimmed>
                    {inputValue && maxLength && (
                        <Div
                            small
                            float-right
                            compact
                            slightShadow
                            ash={inputLength < maxLength}
                            danger={inputLength > maxLength}
                            style={{ marginTop: "-10px" }}
                        >
                            {inputLength}/{maxLength}
                        </Div>
                    )}
                    {header}
                    {help && (
                        <Div tiny italics txtHalf gapSlice>
                            {help}
                        </Div>
                    )}
                </Div>
            )}
            <Div ash ht={"calc(100% - 60px)"} flex>
                <Div wd="30px" fullht />
                <Div fluid white wd="calc(100% - 30px)" fullht autoOverflow>
                    <CKEditor
                        editor={Editor}
                        data={inputValue}
                        config={{
                            link: {
                                // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
                                addTargetToExternalLinks: true,
                            },
                        }}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            setInputValue(data);
                        }}
                    />
                </Div>
            </Div>
        </Div>
    );
}
